<template>
  <b-container fluid class="pb-4">
    <h1 class="fc-h1">{{ $i18n.t("trace.title") }}</h1>
    <b-tabs v-model="type" content-class="mt-3">
      <b-tab :title="this.$i18n.t('trace.tab_operator')">
        <form>
          <b-card :title="this.$i18n.t('trace.label_edit')" class="w-50 mb-3">
                <b-form-group
                  id="machine"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  :label="this.$i18n.t('trace.label_machine')"
                  label-for="input-horizontal"
                >
                  <b-form-input v-model="machine" disabled=true :placeholder="this.$i18n.t('trace.machine_placeholder')" maxlength="40"></b-form-input>
                </b-form-group>
                <b-form-group
                  id="opId"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  :label="this.$i18n.t('trace.label_mailaddress_mandatory')"
                  label-for="input-horizontal"
                >
                  <b-form-input v-model="opId" :placeholder="this.$i18n.t('trace.user_id_placeholder')" maxlength="100"></b-form-input>
                </b-form-group>
                <div>
                  <b-button variant="primary" @click="registUser" class="float-right px-5">{{ $i18n.t("trace.button_add") }}</b-button>
                </div>
          </b-card>
          <b-card>
            <b-row class="d-flex align-items-center">
              <b-col sm="1" md="1" class="my-1" style="margin-right: 2rem;">
                <b-dropdown right variant="primary" :text=lblAction>
                  <b-dropdown-item @click="validUser" >{{ $i18n.t("trace.button_delete") }}</b-dropdown-item>
                </b-dropdown>
              </b-col>
              <b-col sm="9" md="1" class="my-1">
                <b-form-select
                  v-model="userPerPage"
                  id="userPerPageSelect"
                  size="sm"
                  :options="pageOptions"
                ></b-form-select>
              </b-col>
              <b-col sm="9" md="9" class="my-1">
                <b-pagination
                  v-model="userCurrentPage"
                  :total-rows="userTotalRows"
                  :per-page="userPerPage"
                  align="fill"
                  size="sm"
                  class="my-0"
                ></b-pagination>
              </b-col>
            </b-row>
            <b-table
              :striped="striped"
              :bordered="bordered"
              :borderless="borderless"
              :outlined="outlined"
              :current-page="userCurrentPage"
              :per-page="userPerPage"
              :small="small"
              :hover="hover"
              :dark="dark"
              :fixed="fixed"
              :foot-clone="footClone"
              :no-border-collapse="noCollapse"
              :items="userItems"
              :fields="userFields"
              :head-variant="headVariant"
              :table-variant="tableVariant"
              :tbody-tr-class="rowClass"
            >
              <template v-slot:head(action)="row">
                <b-form inline>
                  <b-form-checkbox size="lg" v-model="isAllCheckedUser" v-on:change="selectUserAll" name="check-button"></b-form-checkbox>
                </b-form>
              </template>
              <template v-slot:cell(action)="row">
                <b-form-checkbox size="lg" v-model="row.item.selectedFlg" v-on:change="selectUserOne(row.item.index)" name="check-button"></b-form-checkbox>
              </template>
            </b-table>
          </b-card>
        </form>
      </b-tab>
      <b-tab :title="this.$i18n.t('trace.tab_parts')">
        <form>
          <b-card :title="this.$i18n.t('trace.label_edit')" class="w-50 mb-3">
                <b-form-group
                  id="machine"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  :label="this.$i18n.t('trace.label_machine')"
                  label-for="input-horizontal"
                >
                  <b-form-input v-model="machine" disabled=true :placeholder="this.$i18n.t('trace.machine_placeholder')" maxlength="40"></b-form-input>
                </b-form-group>
                <b-form-group
                  id="partsSerial"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  :label="this.$i18n.t('trace.label_parts_serial_mandatory')"
                  label-for="input-horizontal"
                >
                  <b-form-input v-model="partsSerial" :placeholder="this.$i18n.t('trace.parts_serial_placeholder')" maxlength="40"></b-form-input>
                </b-form-group>
                <div>
                  <b-button variant="primary" @click="registParts" class="float-right px-5">{{ $i18n.t("trace.button_add") }}</b-button>
                </div>
          </b-card>
          <b-card>
            <b-row class="d-flex align-items-center">
              <b-col sm="1" md="1" class="my-1" style="margin-right: 2rem;">
                <b-dropdown right variant="primary" :text=lblAction>
                  <b-dropdown-item @click="validParts" >{{ $i18n.t("trace.button_delete") }}</b-dropdown-item>
                </b-dropdown>
              </b-col>
              <b-col sm="1" md="1" class="my-1">
                <b-form-select
                  v-model="partsPerPage"
                  id="partsPerPageSelect"
                  size="sm"
                  :options="pageOptions"
                ></b-form-select>
              </b-col>
              <b-col sm="9" md="9" class="my-1">
                <b-pagination
                  v-model="partsCurrentPage"
                  :total-rows="partsTotalRows"
                  :per-page="partsPerPage"
                  align="fill"
                  size="sm"
                  class="my-0"
                ></b-pagination>
              </b-col>
            </b-row>
            <b-table
              :striped="striped"
              :bordered="bordered"
              :borderless="borderless"
              :outlined="outlined"
              :current-page="partsCurrentPage"
              :per-page="partsPerPage"
              :small="small"
              :hover="hover"
              :dark="dark"
              :fixed="fixed"
              :foot-clone="footClone"
              :no-border-collapse="noCollapse"
              :items="partsItems"
              :fields="partsFields"
              :head-variant="headVariant"
              :table-variant="tableVariant"
              :tbody-tr-class="rowClass"
            >
              <template v-slot:head(action)="row">
                <b-form inline>
                  <b-form-checkbox size="lg" v-model="isAllCheckedParts" v-on:change="selectPartsAll" name="check-button"></b-form-checkbox>
                </b-form>
              </template>
              <template v-slot:cell(action)="row">
                <b-form-checkbox size="lg" v-model="row.item.selectedFlg" v-on:change="selectPartsOne(row.item.index)" name="check-button"></b-form-checkbox>
              </template>
            </b-table>
          </b-card>
        </form>
      </b-tab>
      <b-tab :title="this.$i18n.t('trace.tab_tool')">
        <form>
          <b-card :title="this.$i18n.t('trace.label_edit')" class="w-50 mb-3">
                <b-form-group
                  id="machine"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  :label="this.$i18n.t('trace.label_machine')"
                  label-for="input-horizontal"
                >
                  <b-form-input v-model="machine" disabled=true :placeholder="this.$i18n.t('trace.machine_placeholder')" maxlength="40"></b-form-input>
                </b-form-group>
                <b-form-group
                  id="toolSerial"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  :label="this.$i18n.t('trace.label_tool_serial_mandatory')"
                  label-for="input-horizontal"
                >
                  <b-form-input v-model="toolSerial" :placeholder="this.$i18n.t('trace.tool_serial_placeholder')" maxlength="20"></b-form-input>
                </b-form-group>
                <div>
                  <b-button variant="primary" @click="registTool" class="float-right px-5">追加</b-button>
                </div>
          </b-card>
          <b-card>
            <b-row class="d-flex align-items-center">
              <b-col sm="1" md="1" class="my-1" style="margin-right: 2rem;">
                <b-dropdown right variant="primary" :text=lblAction>
                  <b-dropdown-item @click="validTool" >{{ $i18n.t("trace.button_delete") }}</b-dropdown-item>
                </b-dropdown>
              </b-col>
              <b-col sm="1" md="1" class="my-1">
                <b-form-select
                  v-model="toolPerPage"
                  id="toolPerPageSelect"
                  size="sm"
                  :options="pageOptions"
                ></b-form-select>
              </b-col>
              <b-col sm="9" md="9" class="my-1">
                <b-pagination
                  v-model="toolCurrentPage"
                  :total-rows="toolTotalRows"
                  :per-page="toolPerPage"
                  align="fill"
                  size="sm"
                  class="my-0"
                ></b-pagination>
              </b-col>
            </b-row>
            <b-table
              :striped="striped"
              :bordered="bordered"
              :borderless="borderless"
              :outlined="outlined"
              :current-page="toolCurrentPage"
              :per-page="toolPerPage"
              :small="small"
              :hover="hover"
              :dark="dark"
              :fixed="fixed"
              :foot-clone="footClone"
              :no-border-collapse="noCollapse"
              :items="toolItems"
              :fields="toolFields"
              :head-variant="headVariant"
              :table-variant="tableVariant"
              :tbody-tr-class="rowClass"
            >
              <template v-slot:head(action)="row">
                <b-form inline>
                  <b-form-checkbox size="lg" v-model="isAllCheckedTools" v-on:change="selectToolAll" name="check-button"></b-form-checkbox>
                </b-form>
              </template>
              <template v-slot:cell(action)="row">
                <b-form-checkbox size="lg" v-model="row.item.selectedFlg" v-on:change="selectToolOne(row.item.index)" name="check-button"></b-form-checkbox>
              </template>
            </b-table>
          </b-card>
        </form>
      </b-tab>
    </b-tabs>
    <confirmModal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
    <confirmModal modId="md-info" :msg="infoMsg" :titleMsg="infoSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="infoConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'

export default {
  components: {
    confirmModal
  },
  data () {
    return {
      userTotalRows: 1,
      partsTotalRows: 1,
      toolTotalRows: 1,
      type: 0,
      machine: null,
      opId: null,
      partsSerial: null,
      toolSerial: null,
      pageOptions: [10, 20, 50, 100],
      userCurrentPage: 1,
      partsCurrentPage: 1,
      toolCurrentPage: 1,
      userPerPage: 10,
      partsPerPage: 10,
      toolPerPage: 10,
      userFields: [
        { key: 'action', label: '' },
        { key: 'opId', label: 'ユーザID', sortable: true },
        { key: 'opName', label: 'ユーザ名', sortable: true }
      ],
      userItems: [
      ],
      partsFields: [
        { key: 'action', label: '' },
        { key: 'serial', label: '部品シリアル', sortable: true },
        { key: 'code', label: '部品型番', sortable: true },
        { key: 'kind', label: '部品種別', sortable: true },
        { key: 'maker', label: '部品メーカ', sortable: true }
      ],
      partsItems: [
      ],
      toolFields: [
        { key: 'action', label: '' },
        { key: 'serial', label: '治工具シリアル', sortable: true },
        { key: 'code', label: '治工具型番', sortable: true },
        { key: 'kind', label: '治工具種別', sortable: true },
        { key: 'maker', label: '治工具メーカ', sortable: true }
      ],
      toolItems: [
      ],
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      noCollapse: true,
      isSearch: false,
      lblAction: this.$i18n.t('trace.button_action'),
      isAllCheckedUser: false,
      isAllCheckedParts: false,
      isAllCheckedTools: false,
      errMsg: null,
      errSbj: this.$i18n.t('common.title_modal_error'),
      infoMsg: null,
      infoSbj: this.$i18n.t('trace.title')
    }
  },
  methods: {
    registUser: function () {
      var machineId = this.$store.store.state.machineId
      var opid = this.opId

      // 入力チェック
      if (opid === null || opid === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('trace.err_user_hissu')
        this.$bvModal.show('md-err')
        return
      }

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      // パラメータ取得
      var body = {}
      if (machineId != null) {
        body.machine = String(machineId)
      }
      body.user = opid

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/trace/userAdd', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.infoMsg = this.$i18n.t(res.data.message)
            this.$bvModal.show('md-info')
            this.getTraceInfo()
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
      this.opId = null
    },
    registParts: function () {
      var machineId = this.$store.store.state.machineId
      var partsSerial = this.partsSerial

      // 入力チェック
      if (partsSerial === null || partsSerial === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('trace.err_parts_serial_hissu')
        this.$bvModal.show('md-err')
        return
      }

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      // パラメータ取得
      var body = {}
      if (machineId != null) {
        body.machine = String(machineId)
      }
      body.parts = partsSerial

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/trace/partsAdd', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              // this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.infoMsg = this.$i18n.t(res.data.message)
            this.$bvModal.show('md-info')
            this.getTraceInfo()
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
      this.partsSerial = null
    },
    registTool: function () {
      var machineId = this.$store.store.state.machineId
      var toolSerial = this.toolSerial

      // 入力チェック
      if (toolSerial === null || toolSerial === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('trace.err_tool_serial_hissu')
        this.$bvModal.show('md-err')
        return
      }

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      // パラメータ取得
      var body = {}
      if (machineId != null) {
        body.machine = String(machineId)
      }
      body.tool = toolSerial

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/trace/toolAdd', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              // this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.infoMsg = this.$i18n.t(res.data.message)
            this.$bvModal.show('md-info')
            this.getTraceInfo()
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
      this.toolSerial = null
    },
    validUser: function () {
      var machineId = this.$store.store.state.machineId

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      // パラメータ取得
      var body = {}
      var userIdStr = ''
      if (machineId != null) {
        body.machine = String(machineId)
      }

      for (var i = 0; i < this.userItems.length; i++) {
        if (this.userItems[i].selectedFlg) {
          if (userIdStr === '') {
            userIdStr = this.userItems[i].op
          } else {
            userIdStr = userIdStr + ',' + this.userItems[i].op
          }
        }
      }

      if (userIdStr === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('toolmente.err_not_selected')
        this.$bvModal.show('md-err')
        return
      }

      body.userId = userIdStr

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/trace/userDelete', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.infoMsg = this.$i18n.t(res.data.message)
            this.$bvModal.show('md-info')
            this.userEfFlgs = []
            this.getTraceInfo()
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    validParts: function () {
      var machineId = this.$store.store.state.machineId

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      // パラメータ取得
      var body = {}
      var partsSerialStr = ''
      if (machineId != null) {
        body.machine = String(machineId)
      }
      for (var i = 0; i < this.partsItems.length; i++) {
        if (this.partsItems[i].selectedFlg) {
          if (partsSerialStr === '') {
            partsSerialStr = this.partsItems[i].serial
          } else {
            partsSerialStr = partsSerialStr + ',' + this.partsItems[i].serial
          }
        }
      }
      body.partsSerial = partsSerialStr

      if (partsSerialStr === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('toolmente.err_not_selected')
        this.$bvModal.show('md-err')
        return
      }

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/trace/partsDelete', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.infoMsg = this.$i18n.t(res.data.message)
            this.$bvModal.show('md-info')
            this.partsEfFlgs = []
            this.getTraceInfo()
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    validTool: function () {
      var machineId = this.$store.store.state.machineId

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      // パラメータ取得
      var body = {}
      var toolSerialStr = ''
      if (machineId != null) {
        body.machine = String(machineId)
      }
      for (var i = 0; i < this.toolItems.length; i++) {
        if (this.toolItems[i].selectedFlg) {
          if (toolSerialStr === '') {
            toolSerialStr = this.toolItems[i].serial
          } else {
            toolSerialStr = toolSerialStr + ',' + this.toolItems[i].serial
          }
        }
      }

      if (toolSerialStr === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('toolmente.err_not_selected')
        this.$bvModal.show('md-err')
        return
      }

      body.toolSerial = toolSerialStr

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/trace/toolDelete', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.infoMsg = this.$i18n.t(res.data.message)
            this.$bvModal.show('md-info')
            this.toolEfFlgs = []
            this.getTraceInfo()
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    selectUserAll () {
      if (this.isAllCheckedUser) {
        this.isAllCheckedUser = false
        for (var i = 0; i < this.userItems.length; i++) {
          this.userItems[i].selectedFlg = false
        }
      } else {
        for (var j = 0; j < this.userItems.length; j++) {
          this.userItems[j].selectedFlg = true
        }
        this.isAllCheckedUser = true
      }
    },
    selectUserOne: function (index) {
      this.userItems[index].selectedFlg = !this.userItems[index].selectedFlg
      var cnt = this.getSelectedCnt(this.userItems)
      if (this.userItems.length !== cnt) {
        this.isAllCheckedUser = false
      } else {
        this.isAllCheckedUser = true
      }
    },
    selectPartsAll () {
      if (this.isAllCheckedParts) {
        this.isAllCheckedParts = false
        for (var i = 0; i < this.partsItems.length; i++) {
          this.partsItems[i].selectedFlg = false
        }
      } else {
        this.isAllCheckedParts = true
        for (var j = 0; j < this.partsItems.length; j++) {
          this.partsItems[j].selectedFlg = true
        }
      }
    },
    selectPartsOne: function (index) {
      this.partsItems[index].selectedFlg = !this.partsItems[index].selectedFlg
      var cnt = this.getSelectedCnt(this.partsItems)
      if (cnt !== this.partsItems.length) {
        this.isAllCheckedParts = false
      } else {
        this.isAllCheckedParts = true
      }
    },
    selectToolAll () {
      if (this.isAllCheckedTools) {
        this.isAllCheckedTools = false
        for (var i = 0; i < this.toolItems.length; i++) {
          this.toolItems[i].selectedFlg = false
        }
      } else {
        this.isAllCheckedTools = true
        for (var j = 0; j < this.toolItems.length; j++) {
          this.toolItems[j].selectedFlg = true
        }
      }
    },
    selectToolOne: function (index) {
      this.toolItems[index].selectedFlg = !this.toolItems[index].selectedFlg
      var cnt = this.getSelectedCnt(this.toolItems)
      if (cnt !== this.toolItems.length) {
        this.isAllCheckedTools = false
      } else {
        this.isAllCheckedTools = true
      }
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    },
    infoConfirm: function () {
      this.$bvModal.hide('md-info')
    },
    getTraceInfo: function () {
      var machineId = this.$store.store.state.machineId

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      // パラメータ取得
      var body = {}
      if (machineId != null) {
        body.machine = String(machineId)
      }

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/trace/select', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            // 取得データセット
            var userList = res.data.userInfo
            var partsList = res.data.partsInfo
            var toolList = res.data.toolInfo
            var counts = []
            // ユーザ整形
            for (var i = 0; i < userList.length; i++) {
              var count = {}
              count.action = false
              count.op = userList[i].op_id
              count.opId = userList[i].mail_address
              count.opName = userList[i].op_name
              count.selectedFlg = false
              count.index = i
              counts.push(count)
            }
            this.userItems.splice(0)
            this.userItems.splice(0, 0, ...counts)
            this.userTotalRows = this.userItems.length

            // 部品整形
            var partses = []
            for (var p = 0; p < partsList.length; p++) {
              var parts = {}
              parts.action = false
              parts.serial = partsList[p].parts_serial
              parts.code = partsList[p].parts_code
              parts.kind = partsList[p].parts_kind
              parts.maker = partsList[p].parts_maker
              parts.selectedFlg = false
              parts.index = p
              partses.push(parts)
            }
            this.partsItems.splice(0)
            this.partsItems.splice(0, 0, ...partses)
            this.partsTotalRows = this.partsItems.length

            // 治工具整形
            var tools = []
            for (var t = 0; t < toolList.length; t++) {
              var tool = {}
              tool.action = false
              tool.serial = toolList[t].tool_serial
              tool.code = toolList[t].tool_code
              tool.kind = toolList[t].tool_kind
              tool.maker = toolList[t].tool_maker
              tool.selectedFlg = false
              tool.index = t
              tools.push(tool)
            }
            this.toolItems.splice(0)
            this.toolItems.splice(0, 0, ...tools)
            this.toolTotalRows = this.toolItems.length

            // 設備名セット
            this.machine = res.data.machneName
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    getSelectedCnt: function (ary) {
      var cnt = 0
      for (var i = 0; i < ary.length; i++) {
        if (ary[i].selectedFlg) {
          cnt++
        }
      }
      return cnt
    }
  },
  created () {
    // 種別取得
    var type = this.$route.query.type
    if (type === '1') {
      this.type = 0
    } else if (type === '2') {
      this.type = 1
    } else if (type === '3') {
      this.type = 2
    }
    this.getTraceInfo()
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/TracementeEdit.vue